import * as Sentry from "@sentry/react";
import type { SeverityLevel } from "@sentry/react";

const isProduction = process.env.NODE_ENV === "production";

export function captureError(
  error: unknown,
  severity: SeverityLevel = "error",
  context?: Record<string, unknown>
): void {
  if (!isProduction) return;

  Sentry.withScope((scope) => {
    scope.setLevel(severity);

    if (context) {
      scope.setContext("details", context);
    }

    Sentry.captureException(error);
  });
}
